import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ParaguayFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15711'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15711)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#E33F39'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#124BBA'
				/>
				<path
					d='M10.0008 8.73331C10.9675 8.73331 11.7627 7.96359 11.7627 6.99998C11.7627 6.03637 10.9675 5.26664 10.0008 5.26664C9.03414 5.26664 8.23893 6.03637 8.23893 6.99998C8.23893 7.96359 9.03414 8.73331 10.0008 8.73331Z'
					stroke='#398153'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 7.46666C10.2626 7.46666 10.4758 7.25772 10.4758 6.99999C10.4758 6.74226 10.2626 6.53333 9.99963 6.53333C9.73664 6.53333 9.52344 6.74226 9.52344 6.99999C9.52344 7.25772 9.73664 7.46666 9.99963 7.46666Z'
					fill='#E5CF58'
				/>
			</g>
		</svg>
	);
};

export default ParaguayFlagIcon;
